import { forwardRef } from 'react';
import { ControllerFieldState } from 'react-hook-form';

import { ESize, SelectSize } from '@core/type';

import { InputBase, InputBorder } from '../input';
import { FieldError } from '../input/FieldError';
import { BoxProps } from '../layout';
import { StyledSelectBaseIcon } from '../select/SelectBaseIcon';
import { StyledSelectBaseWrapper } from '../select/SelectBaseWrapper';

export const DatepickerInput = forwardRef<
  HTMLInputElement,
  {
    value?: string;
    onClick?: () => void;
    size: SelectSize;
    isOpen: boolean;
    id: string;
    width?: BoxProps['width'];
    fieldState: ControllerFieldState;
    isError?: boolean;
    isSuccess?: boolean;
    isSubmitted?: boolean;
    placeholder?: string;
  }
>(
  (
    {
      value,
      onClick,
      size,
      isOpen,
      id,
      width,
      fieldState,
      isError: defaultIsError,
      isSuccess: defaultIsSuccess,
      isSubmitted,
      placeholder,
    },
    ref,
  ) => {
    const isError = fieldState
      ? !!fieldState.error && (fieldState.isTouched || isSubmitted)
      : defaultIsError;
    const isSuccess = fieldState ? !!value : defaultIsSuccess;

    return (
      <>
        <StyledSelectBaseWrapper size={size} padding={'0 16px'} onClick={onClick} width={width}>
          <InputBorder isError={isError} isSuccess={isSuccess} isFocus={isOpen} width={'100%'} />
          <InputBase
            value={value}
            readOnly
            ref={ref}
            id={id}
            width={'100%'}
            placeholder={placeholder}
          />
          <StyledSelectBaseIcon size={ESize.MD} isOpen={isOpen} />
        </StyledSelectBaseWrapper>
        <FieldError fieldState={fieldState} isError={isError} isSubmitted={isSubmitted} />
      </>
    );
  },
);

DatepickerInput.displayName = 'DatepickerInput';
